import { useCallback } from "react";

import type { ForNodeType } from "@/components/features/_model/types/auto-generator-for-view-model";

type Props = {
	hotelEmailAddress: string;
	mailTemplate: ForNodeType<string>;

	onSetViewModel: (
		values: {
			key: "mailTemplate";
			value: ForNodeType<string>;
		}[],
	) => void;
};

export const useCampaignEmailTemplates = ({ hotelEmailAddress, mailTemplate, onSetViewModel }: Props) => {
	const onSetMailTemplate = useCallback(
		(value: string) => {
			onSetViewModel([
				{
					key: "mailTemplate",
					value: {
						...mailTemplate,
						value,
					},
				},
			]);
		},
		[mailTemplate, onSetViewModel],
	);

	const isEdited = mailTemplate.isEdited;

	const hasError = Boolean(mailTemplate.error ?? false);

	return {
		hotelEmailAddress,
		isEdited,
		hasError,
		mailTemplate,
		onSetMailTemplate,
	};
};
